// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"c7cdb781","156":"970b9a3e","217":"bccaa2a9","312":"6242e9d7","376":"9f9f7642","669":"e142e8ef","787":"aff831dd","985":"a1413841"}[chunkId] + ".chunk.js";
};